var _path, _path2, _path3, _path4, _path5, _path6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMenuReferrals(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.34,
    d: "M14.1333 5.1416C15.8 6.29993 16.95 8.1416 17.1833 10.2666",
    stroke: "#292D32",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.34,
    d: "M2.9082 10.3083C3.12487 8.19168 4.2582 6.35002 5.9082 5.18335",
    stroke: "#292D32",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.34,
    d: "M6.8252 17.45C7.79186 17.9416 8.89186 18.2166 10.0502 18.2166C11.1669 18.2166 12.2169 17.9666 13.1585 17.5083",
    stroke: "#292D32",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0501 6.41678C11.3295 6.41678 12.3667 5.37957 12.3667 4.10011C12.3667 2.82065 11.3295 1.78345 10.0501 1.78345C8.77061 1.78345 7.7334 2.82065 7.7334 4.10011C7.7334 5.37957 8.77061 6.41678 10.0501 6.41678Z",
    stroke: "#292D32",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M4.02516 16.5999C5.30462 16.5999 6.34183 15.5627 6.34183 14.2832C6.34183 13.0038 5.30462 11.9666 4.02516 11.9666C2.7457 11.9666 1.7085 13.0038 1.7085 14.2832C1.7085 15.5627 2.7457 16.5999 4.02516 16.5999Z",
    stroke: "#292D32",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M15.9749 16.5999C17.2543 16.5999 18.2915 15.5627 18.2915 14.2832C18.2915 13.0038 17.2543 11.9666 15.9749 11.9666C14.6954 11.9666 13.6582 13.0038 13.6582 14.2832C13.6582 15.5627 14.6954 16.5999 15.9749 16.5999Z",
    stroke: "#292D32",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuReferrals);
export default __webpack_public_path__ + "static/media/menuReferrals.1224428ebd1398f6ba3e1ca933cdc8c5.svg";
export { ForwardRef as ReactComponent };